import React, { useEffect, useState } from "react";
import printJS from "print-js";
import { Link, useParams } from "react-router-dom";
import { QRCode } from "antd/lib";
import { ParticipantsIpmService } from "../../Services/ParticipantsIpmService";
import {
  Button,
  Card,
  Col,
  Image,
  message,
  Modal,
  Popconfirm,
  Progress,
  Row,
  Skeleton,
  Space,
  Table,
  Tabs,
  Tag,
  Upload,
} from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { FamilleService } from "../../Services/FamilleService";
import avatar from "../Image/avatar.jpg";
import Exercice from "../Exercice";
import SelectDoc from "../SelectDoc";
import {
  CloudDownloadOutlined,
  DeleteOutlined,
  UploadOutlined,
  TeamOutlined,
  FileTextOutlined,
  PaperClipOutlined,
  DownloadOutlined,
  FilterFilled,
} from "@ant-design/icons";

const DetailsParticipant = () => {
  const { numcont } = useParams();
  const [familleData, setFamilleData] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState("AAA");
  const [documents, setDocuments] = useState([]);
  const [piecejointes, setPieceJointes] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [participantData, setParticipantData] = useState(null);
  const [img, setImg] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false); // Etat pour gérer la visibilité du modal
  const [fileList, setFileList] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [filteredInfo, setFilteredInfo] = useState({});
  const [uploading, setUploading] = useState(false);

  const benefService = new FamilleService();
  const participantsIpmService = new ParticipantsIpmService();

  const defaultAvatar = avatar;

  const showModal = () => {
    setIsModalVisible(true);
  };

  // Fonction pour fermer le modal
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Fonction pour gérer l'upload des fichiers
  const handleUpload = ({ fileList }) => {
    setFileList(fileList);
  };

  // Fonction pour gérer l'enregistrement des fichiers via l'API
  const handleUploadFile = async () => {
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append("files", file.originFileObj); // Ajouter les fichiers binaires au payload
    });

    setUploading(true);
    try {
      // Appel de l'API pour enregistrer les fichiers en tant que binary
      await participantsIpmService.importpiecejointe(numcont, formData);
      message.success("Fichiers téléversés avec succès.");
      handleCancel(); // Fermer le modal après succès
      fetchPieceJointes();
    } catch (error) {
      message.error("Erreur lors du téléversement des fichiers.");
      console.error(error);
    } finally {
      setUploading(false);
    }
  };

  // Supprimer un fichier
  const handleDeleteFile = async (file_id) => {
    try {
      await participantsIpmService.deletepiecejointe(file_id);
      message.success("Fichier supprimé avec succès.");
      setPieceJointes((prev) =>
        prev.filter((item) => item.file_id !== file_id)
      ); // Supprimer le fichier localement après succès
    } catch (error) {
      message.error("Erreur lors de la suppression du fichier.");
      console.error(error);
    }
  };

  // Télécharger un fichier
  const handleDownloadFile = async (file_id, file_name, file_type) => {
    try {
      const responseData = await participantsIpmService.downloadpiecejointe(file_id);

      const fileName = file_name || `piece_jointe_${file_id}`;
      const fileExtension = fileName.split(".").pop()?.toLowerCase();

      const mimeTypeByExtension = {
        pdf: "application/pdf",
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        xls: "application/vnd.ms-excel",
        docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        doc: "application/msword",
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
      };

      const normalizedFileType =
        file_type && file_type !== "application/octet-stream" ? file_type : null;
      const responseBlobType =
        responseData instanceof Blob && responseData.type && responseData.type !== "application/octet-stream"
          ? responseData.type
          : null;

      const contentType =
        normalizedFileType ||
        responseBlobType ||
        mimeTypeByExtension[fileExtension] ||
        "application/octet-stream";

      // Recrée toujours le Blob avec un type fiable pour éviter l'affichage binaire brut dans le navigateur
      const blob = new Blob([responseData], { type: contentType });

      const url = window.URL.createObjectURL(blob);
      const isPdf = fileExtension === "pdf" || contentType.includes("pdf");

      // Ouvrir dans une nouvelle fenêtre pour les PDF, sinon télécharger
      if (isPdf) {
        printJS({
          printable: url,
          type: "pdf",
          showModal: true,
          modalMessage: "Chargement du document...",
          onLoadingEnd: () => window.URL.revokeObjectURL(url),
          onError: () => {
            window.URL.revokeObjectURL(url);
            message.error("Erreur lors de l'affichage du PDF.");
          },
        });
      } else {
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }

      message.success("Fichier téléchargé avec succès.");
    } catch (error) {
      message.error("Erreur lors du téléchargement du fichier.");
      console.error(error);
    }
  };

  // Récupérer les ayants droit et les informations du participant
  useEffect(() => {
    const fetchParticipantData = async () => {
      try {
        const familleData = await benefService.getAllBeneciaire(numcont);
        setFamilleData(familleData);

        const participantData =
          await participantsIpmService.getOneListParticipant(numcont);
        setParticipantData(participantData);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des ayants droits",
          error
        );
      }
    };

    if (numcont) {
      fetchParticipantData();
    }
  }, [numcont]);

  // Récupérer l'image du participant
  useEffect(() => {

    const fetchImg = async () => {
      console.log(numcont);

      try {
        const image = await participantsIpmService.fetchImgDetail(numcont);
        if (image) {
          setImg(image);
        } else {
          console.error("Image non trouvée ou matripart incorrect");
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };
    if (numcont) {
      fetchImg();
    }
  }, [numcont]);

  const filteredFamilleData = familleData.filter(
    (item) => item.codebenef !== "1"
  );
  const nbrenf = filteredFamilleData.reduce(
    (sum, record) => sum + (record.codebenef === "3" ? 1 : 0),
    0
  );
  const nbrfem = filteredFamilleData.reduce(
    (sum, record) => sum + (record.codebenef === "2" ? 1 : 0),
    0
  );
  const epoux = filteredFamilleData.reduce(
    (sum, record) => sum + (record.codebenef === "4" ? 1 : 0),
    0
  );

  // Récupérer les documents en fonction de l'année sélectionnée
  const fetchDocuments = async (year) => {
    try {
      const data = await participantsIpmService.documentList(numcont, year);
      setDocuments(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des documents :", error);
    }
  };
  const fetchPieceJointes = async () => {
    try {
      const data = await participantsIpmService.piecejointes(numcont);
      setPieceJointes(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des documents :", error);
    }
  };
  useEffect(() => {
    fetchPieceJointes();
  }, []);

  // Cette fonction est appelée uniquement lorsque l'utilisateur change l'année
  const handleExerciceChange = (year) => {
    if (year && year !== selectedYear) {
      // S'assure que l'année est nouvelle avant de faire l'appel
      setSelectedYear(year); // Mettre à jour l'année sélectionnée
      fetchDocuments(year); // Charger les documents pour cette année
    }
  };

  // Ne pas appeler fetchDocuments tant que selectedYear est null
  useEffect(() => {
    if (numcont && selectedYear) {
      fetchDocuments(selectedYear); // Charger les documents lorsque l'année et le participant changent
    }
  }, [numcont, selectedYear]);

  const isLoading = !participantData;

  const onchangeDoc = (value) => setSelectedDoc(value);

  const handleDocumentTableChange = (_, filters) => {
    setFilteredInfo(filters || {});
  };

  const handleExportExcel = () => {
    try {
      const XLSX = require("xlsx");
      const exportData = documents.map((doc) => ({
        Numéro: doc.numdoc,
        Type: doc.typedoc,
        Date: doc.datedoc,
        "Type Bénéf": doc.typebenef,
        Bénéficiaire: doc.beneficiaire,
        Prestataire: doc.fournisseur,
        Etat: doc.etat,
      }));
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      worksheet["!cols"] = [
        { wch: 12 }, { wch: 25 }, { wch: 12 }, { wch: 15 },
        { wch: 22 }, { wch: 22 }, { wch: 10 },
      ];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Documents");
      XLSX.writeFile(workbook, `Documents_${new Date().toISOString().split("T")[0]}.xlsx`);
      message.success("Export Excel réalisé avec succès.");
    } catch (error) {
      message.error("Erreur lors de l'export Excel.");
      console.error(error);
    }
  };

  // Fonction pour mapper les types MIME en labels lisibles
  const getMimeTypeLabel = (mimeType) => {
    if (!mimeType) return "INCONNU";

    // Normaliser le type MIME (enlever les espaces et convertir en minuscules)
    const normalizedType = mimeType.trim().toLowerCase();

    const typeMapping = {
      "application/pdf": "PDF",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "WORD",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "EXCEL",
      "application/vnd.ms-excel": "EXCEL",
      "application/msword": "WORD",
      "image/jpeg": "JPEG",
      "image/png": "PNG",
      "image/jpg": "JPG",
      "text/plain": "TXT",
      "application/zip": "ZIP",
      "application/octet-stream": "FICHIER",
    };

    return typeMapping[normalizedType] || normalizedType;
  };

  // Colonnes pour la table des ayants droit
  const columns = [
    {
      title: "Matricule",
      dataIndex: "matribenef",
      key: "matribenef",
      align: "center",
    },
    {
      title: "Type Benef",
      dataIndex: "codebenef",
      key: "codebenef",
      render: (text) => {
        const typeBenef = {
          2: "Epouse",
          3: "Enfant",
          4: "Epoux",
          5: "Ascendant",
          6: "Autre",
        };
        return <span>{typeBenef[text] || "Inconnu"}</span>;
      },
    },
    { title: "Prénom(s)", dataIndex: "prenoms", key: "prenoms" },
    { title: "Nom", dataIndex: "nom", key: "nom" },
    { title: "Adresse", dataIndex: "adresse", key: "adresse" },
    {
      title: "Lieu naissance",
      dataIndex: "lieunaiss",
      key: "lieunaiss",
    },
    { title: "Age", dataIndex: "ageb", key: "ageb", align: "center" },
    { title: "Sexe", dataIndex: "sexe", key: "sexe", align: "center" },
    {
      title: "Etat",
      dataIndex: "suspension_benef",
      key: "suspension_benef",
      align: "center",
      render: (text) => {
        const tagColor = {
          A: "#46de04",
          S: "#f2b305",
          R: "#fa0202",
          W: "#0570f2",
        };
        const tagText = {
          A: "Actif",
          S: "Suspendu",
          R: "Résilié",
          W: "En cours",
        };
        return (
          <Tag color={tagColor[text] || "gray"}>
            {tagText[text] || "Inconnu"}
          </Tag>
        );
      },
    },
    { title: "Majorité", dataIndex: "majorite", key: "majorite" },
    {
      title: "Durée Prog",
      dataIndex: "duree_prog",
      key: "duree_prog",
      align: "center",
    },
  ];

  // Colonnes pour les documents
  const documentColumns = [
    { title: "Numero", dataIndex: "numdoc", key: "numdoc", align: "center" },
    {
      title: (
        <span style={{ color: filteredInfo.typedoc?.length ? "#1677ff" : undefined, fontWeight: filteredInfo.typedoc?.length ? 700 : 500 }}>
          Type
        </span>
      ),
      dataIndex: "typedoc",
      key: "typedoc",
      align: "center",
      filters: Array.from(new Set(documents.map((doc) => doc.typedoc).filter(Boolean))).map((value) => ({
        text: value,
        value,
      })),
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#1677ff" : "#bfbfbf", fontSize: 14 }} />
      ),
      onFilter: (value, record) => record.typedoc === value,
    },
    {
      title: "Date",
      dataIndex: "datedoc",
      key: "doc",
      align: "center",
      render: (text) => {
        if (!text) return "";
        const d = new Date(text);
        if (isNaN(d)) return text;
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      title: (
        <span style={{ color: filteredInfo.typebenef?.length ? "#1677ff" : undefined, fontWeight: filteredInfo.typebenef?.length ? 700 : 500 }}>
          Type bénéf
        </span>
      ),
      dataIndex: "typebenef",
      key: "typebenef",
      align: "center",
      filters: Array.from(new Set(documents.map((doc) => doc.typebenef).filter(Boolean))).map((value) => ({
        text: value,
        value,
      })),
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#1677ff" : "#bfbfbf", fontSize: 14 }} />
      ),
      onFilter: (value, record) => record.typebenef === value,
    },
    { title: "Bénéficiaire", dataIndex: "beneficiaire", key: "beneficiaire" },
    { title: "Prestataire", dataIndex: "fournisseur", key: "fournisseur" },
    {
      title: (
        <span style={{ color: filteredInfo.etat?.length ? "#1677ff" : undefined, fontWeight: filteredInfo.etat?.length ? 700 : 500 }}>
          Etat
        </span>
      ),
      dataIndex: "etat",
      key: "etat",
      align: "center",
      filters: Array.from(new Set(documents.map((doc) => doc.etat).filter(Boolean))).map((value) => ({
        text: value === "OK" ? "traité" : value === "KO" ? "En cour" : value,
        value,
      })),
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#1677ff" : "#bfbfbf", fontSize: 14 }} />
      ),
      onFilter: (value, record) => record.etat === value,
      render: (text) => {
        const tagColor = {
          OK: "#46de04",
          KO: "#f2b305",
        };
        const tagText = {
          OK: "traité",
          KO: "En cour",
        };
        return (
          <Tag color={tagColor[text] || "gray"}>
            {tagText[text] || "Inconnu"}
          </Tag>
        );
      },
    },
  ];
  const piecesjointesColumns = [
    { title: "Numéro", dataIndex: "file_id", key: "file_id", align: "center" },
    { title: "Nom du fichier", dataIndex: "file_name", key: "file_name" },
    {
      title: "Type",
      dataIndex: "file_type",
      key: "file_type",
      render: (text) => {
        return <span style={{ fontWeight: 500 }}>{getMimeTypeLabel(text)}</span>;
      },
    },
    {
      title: "Taille (Ko)",
      dataIndex: "file_size",
      key: "file_size",
      align: "center",
    },
    {
      // title: "Action",
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      align: "center",
      fixed: "right",
      render: (text, record) => (
        <Space>
          <Button
            type="text"
            icon={
              <CloudDownloadOutlined
                style={{ cursor: "pointer", color: "green" }}
              />
            }
            onClick={() => handleDownloadFile(record.file_id, record.file_name, record.file_type)}
          />
          <Popconfirm
            title="Supprimer la pièce jointe"
            description="Voulez-vous vraiment supprimer ce fichier ?"
            okText="Oui"
            cancelText="Non"
            onConfirm={() => handleDeleteFile(record.file_id)}
          >
            <Button
              type="text"
              icon={
                <DeleteOutlined style={{ cursor: "pointer", color: "red" }} />
              }
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];
  return (
    <div style={{ padding: "0 0 20px 0" }}>
      {/* En-tête du participant */}
      <Card
        style={{ marginBottom: 20, borderRadius: 8 }}
        bodyStyle={{ padding: 20 }}
      >
        <Row gutter={[24, 24]} align="middle">
          {/* Colonne Gauche : Photo et QR Code */}
          <Col xs={24} sm={24} md={6} lg={5}>
            <div style={{ textAlign: "center" }}>
              <Image
                src={img || defaultAvatar}
                fallback={defaultAvatar}
                alt="avatar"
                width={200}
                height={200}
                style={{
                  objectFit: "cover",
                  borderRadius: 12,
                  border: "3px solid #f0f0f0",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              />
            </div>
          </Col>

          {/* Colonne Milieu : Informations personnelles */}
          <Col xs={24} sm={24} md={9} lg={10}>
            <Space direction="vertical" style={{ width: "100%" }} size="small">
              <div>
                <Skeleton loading={isLoading} active paragraph={{ rows: 0 }} style={{ width: 200 }}>
                  <h2 style={{ margin: 0, color: "#010f1c" }}>
                    {participantData?.prenom} {participantData?.nom}
                  </h2>
                  <p style={{ margin: "4px 0 0 0", color: "#8c8c8c", fontSize: 14 }}>
                    ID: {participantData?.matipm}
                  </p>
                </Skeleton>
              </div>

              <div style={{ paddingTop: 12, borderTop: "1px solid #f0f0f0" }}>
                <Skeleton loading={isLoading} active paragraph={{ rows: 5 }}>
                  <Row gutter={[16, 12]}>
                    <Col span={24}>
                      <p style={{ margin: 0, color: "#595959", fontSize: 13 }}>
                        <span style={{ fontWeight: 600 }}><strong>CIN:</strong></span> {participantData?.cin}
                      </p>
                    </Col>
                    <Col span={24}>
                      <p style={{ margin: 0, color: "#595959", fontSize: 13 }}>
                        <span style={{ fontWeight: 600 }}><strong>Adresse:</strong></span> {participantData?.adresse}
                      </p>
                    </Col>
                    <Col span={12}>
                      <p style={{ margin: 0, color: "#595959", fontSize: 13 }}>
                        <span style={{ fontWeight: 600 }}><strong>Mobile:</strong></span> {participantData?.portable}
                      </p>
                    </Col>
                    <Col span={12}>
                      <p style={{ margin: 0, color: "#595959", fontSize: 13 }}>
                        <span style={{ fontWeight: 600 }}><strong>Email:</strong></span> {participantData?.email}
                      </p>
                    </Col>
                    <Col span={12}>
                      <p style={{ margin: 0, color: "#595959", fontSize: 13 }}>
                        <span style={{ fontWeight: 600 }}><strong>Situation:</strong></span> {participantData?.sitfam}
                      </p>
                    </Col>
                    <Col span={12}>
                      <p style={{ margin: 0, color: "#595959", fontSize: 13 }}>
                        <span style={{ fontWeight: 600 }}><strong>Naissance:</strong></span>{" "}
                        {participantData?.datenaiss
                          ? new Date(participantData.datenaiss).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" })
                          : ""}
                      </p>
                    </Col>
                    <Col span={24}>
                      <p style={{ margin: 0, color: "#595959", fontSize: 13 }}>
                        <span style={{ fontWeight: 600 }}><strong>Lieu:</strong></span> {participantData?.lieunaiss}
                      </p>
                    </Col>
                  </Row>
                </Skeleton>
              </div>
            </Space>
          </Col>

          {/* Colonne Droite : Consommation et Actions */}
          <Col xs={24} sm={24} md={9} lg={9}>
            <Space direction="vertical" style={{ width: "100%" }} size="large">
              <div style={{
                padding: 12,
                backgroundColor: "#fafafa",
                borderRadius: 8,
                border: "1px solid #f0f0f0"
              }}>
                <Skeleton loading={isLoading} active paragraph={{ rows: 3 }} title={false}>
                  <p style={{ margin: "0 0 12px 0", color: "#595959", fontWeight: 500, fontSize: 13 }}>
                    • Age du participant: <strong>{participantData?.agepart} ans</strong>
                  </p>
                  <p style={{ margin: "0 0 12px 0", color: "#595959", fontWeight: 500, fontSize: 13 }}>
                    • Époux/se: <strong>{nbrfem > 0 ? nbrfem : epoux}</strong>
                  </p>
                  <p style={{ margin: 0, color: "#595959", fontWeight: 500, fontSize: 13 }}>
                    • Enfants: <strong>{nbrenf}</strong>
                  </p>
                </Skeleton>
              </div>

              <Space style={{ width: "100%" }}>
                <Link to="/Participants" style={{ flex: 1 }}>
                  <Button className="buttonCompta" style={{ width: "100%" }}>
                    Retour
                  </Button>
                </Link>
                <Link to={`/Participants/edit/${participantData?.numcont}`} style={{ flex: 1 }}>
                  <Button className="buttonCompta" style={{ width: "100%" }}>
                    Modifier
                  </Button>
                </Link>
              </Space>
            </Space>
          </Col>
        </Row>
      </Card>

      {/* Sections en Tabs */}
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        size="large"
        style={{ marginTop: 20 }}
        tabBarStyle={{
          backgroundColor: "#fafafa",
          borderBottom: "2px solid #f0f0f0",
          marginBottom: 0,
        }}
        items={[
          {
            key: "1",
            label: (
              <span>
                <TeamOutlined style={{ marginRight: 8 }} />
                Ayants droits
                <span style={{ marginLeft: 6, backgroundColor: "#010f1c", color: "#fff", borderRadius: 10, padding: "1px 7px", fontSize: 11 }}>
                  {familleData.filter((item) => item.codebenef !== "1").length}
                </span>
              </span>
            ),
            children: (
              <Card
                title={`Famille du participant`}
                bodyStyle={{ padding: 16 }}
                headStyle={{ borderBottom: "1px solid #f0f0f0" }}
              >
                <Table
                  showSorterTooltip={false}
                  dataSource={familleData.filter((item) => item.codebenef !== "1")}
                  columns={columns}
                  scroll={{ x: true }}
                  style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
                  className="custom-header1-table"
                  bordered
                  rowKey="matribenef"
                  pagination={{ pageSize: 10, showSizeChanger: true }}
                />
              </Card>
            ),
          },
          {
            key: "2",
            label: (
              <span>
                <FileTextOutlined style={{ marginRight: 8 }} />
                Documents
                <span style={{ marginLeft: 6, backgroundColor: "#010f1c", color: "#fff", borderRadius: 10, padding: "1px 7px", fontSize: 11 }}>
                  {documents.length}
                </span>
              </span>
            ),
            children: (
              <Card
                title="Documents du participant"
                bodyStyle={{ padding: 16 }}
                headStyle={{ borderBottom: "1px solid #f0f0f0" }}
                extra={
                  <Space>
                    <Exercice
                      source="document"
                      onExerciceChange={handleExerciceChange}
                    />
                    <Button
                      type="primary"
                      icon={<DownloadOutlined />}
                      onClick={handleExportExcel}
                      disabled={documents.length === 0}
                      style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
                    >
                      Export Excel
                    </Button>
                  </Space>
                }
              >
                <Table
                  showSorterTooltip={false}
                  dataSource={documents}
                  columns={documentColumns}
                  scroll={{ x: true }}
                  style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
                  className="custom-header1-table"
                  bordered
                  rowKey="numdoc"
                  onChange={handleDocumentTableChange}
                  pagination={{
                    pageSize: 10,
                    showSizeChanger: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} sur ${total} ligne${total > 1 ? "s" : ""}`,
                  }}
                />
              </Card>
            ),
          },
          {
            key: "3",
            label: (
              <span>
                <PaperClipOutlined style={{ marginRight: 8 }} />
                Pièces jointes
                <span style={{ marginLeft: 6, backgroundColor: "#010f1c", color: "#fff", borderRadius: 10, padding: "1px 7px", fontSize: 11 }}>
                  {piecejointes.length}
                </span>
              </span>
            ),
            children: (
              <Card
                bodyStyle={{ padding: 16 }}
                extra={
                  <Button
                    onClick={showModal}
                    className="Buttonvalid"
                    type="primary"
                  >
                    Joindre pièce
                  </Button>
                }
              >
                <Table
                  showSorterTooltip={false}
                  columns={piecesjointesColumns}
                  dataSource={piecejointes}
                  scroll={{ x: true }}
                  style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
                  className="custom-header1-table"
                  bordered
                  pagination={{ pageSize: 10, showSizeChanger: true }}
                />
              </Card>
            ),
          },
        ]}
      />

      <Modal
        title="Importer des fichiers"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Annuler
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleUploadFile}
            disabled={fileList.length === 0 || uploading}
            loading={uploading}
          >
            Téléverser
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 16 }}>
          <p style={{ color: "#595959", marginBottom: 12 }}>
            Glissez-déposez vos fichiers ou cliquez pour les sélectionner
          </p>
          <Upload.Dragger
            fileList={fileList}
            onChange={handleUpload}
            beforeUpload={(file) => {
              if (file.type !== "application/pdf") {
                message.error("Seuls les fichiers PDF sont autorisés.");
                return Upload.LIST_IGNORE;
              }
              if (file.size > 500 * 1024) {
                message.error("Le fichier ne doit pas dépasser 500 Ko.");
                return Upload.LIST_IGNORE;
              }
              return false;
            }}
            multiple
            accept=".pdf"
            style={{
              padding: 24,
              border: "2px dashed #1890ff",
              borderRadius: 8,
              backgroundColor: "#fafafa",
              cursor: "pointer",
            }}
          >
            <p style={{ fontSize: 16, fontWeight: 500, color: "#010f1c" }}>
              📎 Glissez les fichiers ici
            </p>
            <p style={{ color: "#8c8c8c", marginTop: 8 }}>
              ou cliquez pour sélectionner
            </p>
          </Upload.Dragger>
          {fileList.length > 0 && (
            <div style={{ marginTop: 16 }}>
              <p style={{ color: "#595959", fontWeight: 500 }}>
                Fichiers sélectionnés ({fileList.length}):
              </p>
              <ul style={{ fontSize: 13, color: "#595959" }}>
                {fileList.map((file, index) => (
                  <li key={index}>{file.name}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default DetailsParticipant;
